import React from 'react';
import { useTranslation } from 'react-i18next';
import Seo from '../components/seo/Seo.jsx';
import Hero from './Hero.jsx';
import AssistantSection from './AssistantSection.jsx';
import ContactSection from './ContactSection.jsx';

/**
 * The one-page site for groups that run several companies.
 * @returns {JSX.Element} Landing page
 */
function Landing() {
  const { t } = useTranslation();

  return (
    <>
      <Seo title={t('seo.title')} description={t('seo.description')} />
      <Hero />
      <AssistantSection />
      <ContactSection />
    </>
  );
}

export default Landing;
